export default __webpack_public_path__ + "static/media/ic_hospital_plus.466e425c.svg";